<template>
    <div>
        <el-form ref="form" :model="form" label-width="140px" :rules="rule" class="">
            <el-form-item label="问题:">
                <div class="blues">{{itemxx.name}}</div>
            </el-form-item>
            <el-row>
                <el-col :span="12">
                    <el-form-item label="评论:" v-if="listItem.length>0">
                        <div class="lefts" >
                            <el-timeline >
                                <el-timeline-item v-for="(item,index) in listItem" :key="index" type="info"
                                    :timestamp="item.create_time" placement="top">
                                    <div class="concon">
                                        <div class="u-f u-ac u-jsb">
                                            <div class="u-f u-ac">
                                                <img :src="item.avatar" alt="" class="imgs">
                                                <div>{{item.create_user_text}} </div>
                                            </div>
                                            <div>
                                                <i class="el-icon-delete delt" @click="handleDelete(item)"></i>
                                            </div>
                                        </div>
                                        <div class="u-f u-ac u-jsb">
                                            <div>{{item.reply_content}}</div>
                                            <div class="blues curson" @click="checkxx(item)">点击查看所有回复</div>
                                        </div>
                                        <div v-if="item.CommentReplys.length>0" class="hfxx">
                                            <div v-for="(itemed,indexs) in item.CommentReplys" :key="indexs">
                                                <div class="u-f u-ac">
                                                    <img :src="itemed.create_user_avatar" alt="" class="imgs">
                                                    <div>{{itemed.create_user_text}} <i class="el-icon-caret-right"></i>  {{itemed.to_user_text}}</div>
                                                </div>
                                                <div>
                                                    {{itemed.reply_contents}}
                                                </div>

                                            </div>
                                        </div>
                                        <div v-else>暂无回复内容</div>
                                    </div>
                                </el-timeline-item>
                            </el-timeline>
                        </div>
                        <div class="u-f u-jsb">
                            <div></div>
                            <el-pagination @current-change="handleCurrentChange" :current-page="page"
                                :page-size="page_count" layout="total, prev, pager, next" :total="counts">
                            </el-pagination>
                        </div>
                    </el-form-item>
                    <el-form-item label="评论:" v-else>
                        暂无评论
                    </el-form-item>
                </el-col>
                <el-col :span="12">
                    <el-form-item label="助手" prop="zs_value">
                        <el-select v-model="form.zs_value" placeholder="请选择" filterable size="small">
                            <el-option v-for="item in zs_options" :key="item.id" :label="item.nickname"
                                :value="item.id">
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="评论" prop="textareas">
                        <el-input type="textarea" :rows="4" placeholder="请输入内容" v-model="form.textareas">
                        </el-input>
                    </el-form-item>
                    <el-form-item>
                        <el-button type="primary" size="small" @click="submit('form')">提 交</el-button>
                        <el-button size="small" @click="cancel">重 置</el-button>
                    </el-form-item>
                </el-col>
            </el-row>
        </el-form>


        <el-dialog title="评论回复设置" :visible.sync="dialogs" top="40px" width="70%" center class="dialogs"
            :append-to-body="true">
            <el-divider></el-divider>
            <div class="dialog-ibox-content">
                <el-form ref="forms" :model="forms" label-width="140px" :rules="ruleed" class="">
                    <el-row>
                        <el-col :span="12">
                            <div v-if="hfItem.length>0">
                                <div class="lefts">
                                    <el-timeline >
                                        <el-timeline-item v-for="(item,index) in hfItem" :key="index" type="info"
                                            :timestamp="item.create_time" placement="top">
                                            <div class="concon curson" @click="xzclick(item)">
                                                <div class="u-f u-ac u-jsb">
                                                    <div class="u-f u-ac">
                                                        <img :src="item.create_user_avatar" alt="" class="imgs">
                                                        <div>{{item.create_user_text}} <i class="el-icon-caret-right"></i> {{item.to_user_text}}</div>
                                                    </div>
                                                    <div>
                                                        <i class="el-icon-delete delt" @click="handleDeletes(item)"></i>
                                                    </div>
                                                </div>
                                                <div class="u-f u-ac u-jsb">
                                                    <div>{{item.reply_contents}}</div>
                                                </div>
                                                <div v-if="item.CommentReplys" class="hfxx">
                                                    <div v-for="(itemed,indexs) in item.CommentReplys" :key="indexs">
                                                        <div class="u-f u-ac">
                                                            <img :src="itemed.create_user_avatar" alt="" class="imgs">
                                                            <div>{{itemed.create_user_text}}</div>
                                                        </div>
                                                        <div>
                                                            {{itemed.reply_contents}}
                                                        </div>

                                                    </div>
                                                </div>
                                            </div>
                                        </el-timeline-item>
                                    </el-timeline>
                                </div>
                                <div class="u-f u-jsb">
                                    <div></div>
                                    <el-pagination @current-change="handleCurrentChange" :current-page="page"
                                        layout="total, prev, pager, next" :total="counted">
                                    </el-pagination>
                                </div>
                            </div>
                            <div v-else>
                                <el-form-item label="回复">
                                    暂无回复
                                </el-form-item>
                            </div>
                        </el-col>
                        <el-col :span="12">
                            <el-form-item label="助手" prop="zs_value">
                                <el-select v-model="forms.zs_value" placeholder="请选择" filterable size="small">
                                    <el-option v-for="item in zs_options" :key="item.id" :label="item.nickname"
                                        :value="item.id">
                                    </el-option>
                                </el-select>
                            </el-form-item>
                            <el-form-item label="回复" prop="textareas">
                                <div v-if="xzlist" class="u-f ">
                                    <div> 回复@{{xzlist.create_user_text}}</div> 
                                    <div style="margin-left:10px"><i class="el-icon-close reds" @click="xzlist=''"></i> </div> 
                                </div>
                                <el-input type="textarea" :rows="4" placeholder="请输入内容" v-model="forms.textareas">
                                </el-input>
                            </el-form-item>
                            <el-form-item>
                                <el-button type="primary" size="small" @click="submithf('forms')">提 交</el-button>
                                <el-button size="small" @click="cancels">重 置</el-button>
                            </el-form-item>
                        </el-col>
                    </el-row>
                </el-form>
            </div>
            <el-divider></el-divider>
            <span slot="footer" class="dialog-footer">
                <el-button @click="dialogs = false" size="small">取 消</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
    import {
        mapState
    } from 'vuex'
    export default {
        data() {
            return {

                eid: '',
                source: '',
                page: 1,
                page_count: 10,
                itemxx: '',
                listItem: [],
                counts: 0,
                zs_options: [],
                form: {
                    zs_value: '',
                    textareas: '',
                },
                rule: {
                    textareas: [{
                        required: true,
                        message: '评论不能为空'
                    }],
                    zs_value: [{
                        required: true,
                        message: '助手不能为空'
                    }]
                },
                // 
                dialogs: false,
                hfrow: '',
                hfItem: [],
                counted: 0,
                forms: {
                    zs_value: '',
                    textareas: '',
                },
                ruleed: {
                    textareas: [{
                        required: true,
                        message: '回复不能为空'
                    }],
                    zs_value: [{
                        required: true,
                        message: '助手不能为空'
                    }]
                },
                xzlist: '',
            }
        },
        computed: {
            ...mapState({
                user: state => state.user.user,
            })
        },
        mounted() {},
        methods: {
            getxx() {
                axios
                    .post("/admin/AllComment/HgetComments", {
                        data_id: this.eid,
                        source: this.source,
                        page: this.page,
                        page_count: this.page_count
                    }, {
                        token: true
                    })
                    .then(response => {
                        this.listItem = response.data.data.list
                        this.counts = response.data.data.count
                    })
                    .catch(error => {})
            },
            handleCurrentChange(val) {
                this.page = val
                this.getxx()
            },
            // 获取助手
            getzsxx() {
                let that = this
                axios
                    .post("/admin/doctorAssistantList", {}, {
                        token: true
                    })
                    .then(response => {
                        that.zs_options = response.data.data
                    })
                    .catch(error => {})
            },
            cancel() {
                this.form.zs_value = ''
                this.form.textareas = ''
            },
            submit(formName) {
                let that = this
                that.$refs[formName].validate((valid) => {
                    if (valid) {
                        var obj = this.zs_options.find(item => item.id == this.form.zs_value)
                        
                        axios
                            .post("/admin/AllComment/Hsave", {
                                create_user: this.form.zs_value,
                                data_id: that.eid,
                                reply_content: this.form.textareas,
                                create_user_text: obj.doctorAudit ? obj.doctorAudit.real_name : obj
                                    .nickname,
                                avatar: obj.doctorAudit ? obj.doctorAudit.head_portrait_pic[0].url : obj
                                    .avatar,
                                source: this.source,
                                author: this.form.zs_value,
                            }, {
                                token: true
                            })
                            .then(response => {
                                if (response.data.code == '200') {
                                    that.cancel()
                                    that.getxx()
                                    that.$message({
                                        message: '操作成功',
                                        type: 'success'
                                    });
                                } else {
                                    that.$message.error(response.data.msg);
                                }
                            })
                            .catch(error => {})
                    } else {
                        that.$alert('信息遗漏未填')
                        return false;
                    }
                });
            },
            handleDelete(item) {
                let that = this
                that.$confirm('此操作将永久删除该文件, 是否继续?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    axios
                        .post("/admin/AllComment/Hdel", {
                            id: item.id
                        }, {
                            token: true
                        })
                        .then(response => {
                            if (response.data.code == '200') {
                                that.getxx()
                                that.$message({
                                    type: 'success',
                                    message: '删除成功!'
                                });
                            } else {
                                that.$message.error(response.data.msg);
                            }
                        })
                        .catch(error => {})
                }).catch(() => {
                    that.$message({
                        type: 'info',
                        message: '已取消删除'
                    });
                });
            },
            // 查看回复
            checkxx(item) {
                this.dialogs = true
                this.hfrow = item
                this.cancels()
                this.gethfxx()
            },
            gethfxx() {
                axios
                    .post("/admin/AllReply/HgetReplys", {
                        comment_id: this.hfrow.id,
                        source: this.source,
                        page: this.pages,
                        page_count: 10
                    }, {
                        token: true
                    })
                    .then(response => {
                        if (response.data.code == '200') {
                            this.hfItem = response.data.data.list
                            this.counted = response.data.data.count
                        } else {
                            that.$message.error(response.data.msg);
                        }
                    })
                    .catch(error => {})
            },
            cancels() {
                this.forms.zs_value = ''
                this.forms.textareas = ''
                this.xzlist =''
            },
            handleDeletes(item) {
                let that = this
                that.$confirm('此操作将永久删除该文件, 是否继续?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    axios
                        .post("/admin/AllReply/Hdel", {
                            id: item.id
                        }, {
                            token: true
                        })
                        .then(response => {
                            if (response.data.code == '200') {
                                this.gethfxx()
                                that.$message({
                                    type: 'success',
                                    message: '删除成功!'
                                });
                            } else {
                                that.$message.error(response.data.msg);
                            }
                        })
                        .catch(error => {})
                }).catch(() => {
                    that.$message({
                        type: 'info',
                        message: '已取消删除'
                    });
                });
            },
            xzclick(item) {
                this.xzlist = item
            },
            submithf(formName) {
                let that = this
                that.$refs[formName].validate((valid) => {
                    if (valid) {
                        var obj = this.zs_options.find(item => item.id == this.forms.zs_value)
                        var status = this.xzlist == '' ? '1' : '2'
                        var ids = this.xzlist ? this.xzlist.id : 0
                        axios
                            .post("/admin/AllReply/Hsave", {
                                create_user_avatar: obj.doctorAudit ? obj.doctorAudit.head_portrait_pic[0].url : obj.avatar,
                                reply_contents: this.forms.textareas,
                                author: obj.id,
                                comment_id: this.hfrow.id,
                                to_user_text: this.xzlist ? this.xzlist.create_user_text : this.hfrow.create_user_text,
                                source: this.source,
                                reply_id: ids,
                                reply_type: status,
                                to_user:this.xzlist ? this.xzlist.create_user :  this.hfrow.create_user,
                                create_user_text: obj.doctorAudit ? obj.doctorAudit.real_name : obj.nickname,
                                create_user: this.forms.zs_value
                            }, {
                                token: true
                            })
                            .then(response => {
                                if (response.data.code == '200') {
                                    this.xzlist =''
                                    that.cancels()
                                    that.getxx()
                                    that.gethfxx()
                                    that.$message({
                                        message: '操作成功',
                                        type: 'success'
                                    });
                                } else {
                                    that.$message.error(response.data.msg);
                                }
                            })
                            .catch(error => {})
                    } else {
                        that.$alert('信息遗漏未填')
                        return false;
                    }
                });
            }
        }
    }
</script>

<style lang="scss" scoped>
    .curson {
        cursor: pointer;
    }

    .hfxx {
        padding: 0 30px;
    }
    .lefts{
        padding-right: 10px;
    }
</style>